import styled, { css } from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

import type { SuggestionProps } from './types'

export const DismissButtonContainer = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;

  ${mediaQueries.tablet} {
    top: 4px;
    right: 4px;
  }
`

export const DismissButton = styled.button`
  display: flex;

  align-items: center;
  justify-content: center;

  border-radius: var(--radius-brand);

  padding: var(--space-150);

  &:hover {
    background: var(--bg-transparent);
  }

  ${mediaQueries.tablet} {
    display: none;
  }
`

export const Container = styled.div<{ size: NonNullable<SuggestionProps['size']> }>`
  padding: var(--space-400);
  border-top: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  display: flex;
  flex-direction: column;
  gap: 20px;

  position: relative;

  &:hover {
    ${DismissButton} {
      display: flex;
    }
  }

  ${({ size }) =>
    size === 'large' &&
    css`
      padding: 20px;
    `};

  ${mediaQueries.tablet} {
    padding: var(--space-500);
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);

    display: flex;
    flex-direction: row;
    gap: var(--space-800);

    transition: border-color var(--motion-duration-100) var(--motion-ease-in-out);

    &:hover {
      border-color: var(--border-secondary-hover);
    }

    ${({ size }) =>
      size === 'large' &&
      css`
        padding: 40px;
        gap: 12px;

        align-items: center;
        flex-direction: column-reverse;

        ${Image} {
          height: 202px;
        }

        ${Main} {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          text-align: center;
          gap: 16px;
        }

        ${TextualContent} {
          text-align: center;
          align-items: center;
        }
      `};
  }
`

export const Main = styled.div<{ size?: NonNullable<SuggestionProps['size']> }>`
  flex: 1;

  display: flex;
  gap: 20px;

  ${mediaQueries.tablet} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }
`

export const Image = styled.img`
  height: 70px;

  ${mediaQueries.tablet} {
    height: 140px;
    object-fit: contain;
  }
`

export const SideContent = styled.div`
  display: flex;
  justify-content: center;
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const TextualContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 6px;
  flex: 1;

  ${mediaQueries.tablet} {
    gap: 4px;
  }
}
`

export const TopLevelContent = styled.div`
  margin-bottom: 8px;
`

export const Title = styled.h3`
  font-size: var(--font-size-400);
  font-weight: 600;
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-500);
    line-height: var(--font-line-height-400);
    letter-spacing: var(--font-letter-spacing-denser);
  }
`

export const Badge = styled.span`
  ${mediaQueries.tablet} {
    display: inline-block;
    margin-left: 12px;

    position: relative;
    bottom: 3px;
  }
`

export const Award = styled.span`
  ${mediaQueries.tablet} {
    display: inline-block;
    margin-left: 12px;
  }
`

export const Description = styled.p`
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  ${mediaQueries.tablet} {
    letter-spacing: var(--font-letter-spacing-normal);
    line-height: var(--font-line-height-400);
    font-size: var(--font-size-400);
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: center;

  ${mediaQueries.tablet} {
    align-self: stretch;
    display: block;
    width: auto;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;

  display: inline-block;

  ${mediaQueries.tablet} {
    width: auto;
  }
`
